import React, { useState, useContext, useEffect, useRef } from "react";
import { Link, Redirect } from "react-router-dom";
import "./maturity-dashboard-admin-page.scss";
import {
  MaturityPlantSetupPopup,
  MaturitySubmitDataPopup,
  AssignSectionPopup,
  MaturityAddUserPopup,
} from "./maturity-admin-popup";
import { MaturityOverView } from "./maturity-admin-overview";
import * as d3 from "d3";
import { tip as d3tip } from "d3-v6-tip";
import { CartContext } from "../../contexts/CartContext";
import serviceProvider from '../../services/axios'
import $, { isEmptyObject } from "jquery";
import { exit } from "process";
const data = [
  {
    week: "Week 1",
    "Maturity Assessment": 5,
    "Loss Analysis": 3,
    Training: 2,
  },
  {
    week: "Week 2",
    "Maturity Assessment": 15,
    "Loss Analysis": 3,
    Training: 8,
  },
  {
    week: "Week 3",
    "Maturity Assessment": 10,
    "Loss Analysis": 12,
    Training: 11,
  },
  {
    week: "Week 4",
    "Maturity Assessment": 12,
    "Loss Analysis": 20,
    Training: 0,
  },
  {
    week: "Week 5",
    "Maturity Assessment": 0,
    "Loss Analysis": 2,
    Training: 0,
  },
  {
    week: "Week 6",
    "Maturity Assessment": 8,
    "Loss Analysis": 0,
    Training: 0,
  },
  {
    week: "Week 7",
    "Maturity Assessment": 5,
    "Loss Analysis": 9,
    Training: 0,
  },
  {
    week: "Week 8",
    "Maturity Assessment": 9,
    "Loss Analysis": 6,
    Training: 0,
  },
  {
    week: "Week 9",
    "Maturity Assessment": 28,
    "Loss Analysis": 4,
    Training: 0,
  },
  {
    week: "Week 10",
    "Maturity Assessment": 27,
    "Loss Analysis": 0,
    Training: 15,
  },
  {
    week: "Week 11",
    "Maturity Assessment": 15,
    "Loss Analysis": 25,
    Training: 0,
  },
  {
    week: "Week 12",
    "Maturity Assessment": 5,
    "Loss Analysis": 6,
    Training: 4,
  },
  {
    week: "Week 13",
    "Maturity Assessment": 20,
    "Loss Analysis": 4,
    Training: 1,
  },
  {
    week: "Week 14",
    "Maturity Assessment": 10,
    "Loss Analysis": 5,
    Training: 20,
  },
];
export const MaturityDashboardAdminView = (props) => {
  const losspdata = props.resp.lossbuy;
  const matdata = props.resp.fmabuy;
  const asu = props.resp.asu;
  const lossprogadmin = props.lossprogresResult;

  // console.log("lossprog",props.lossprogresResult)

  const [isAddPlantPopup, setIsAddPlantPopup] = useState(false);
  const [isSubmitDataPopup, setIsSubmitDataPopup] = useState(false);
  const [isAssignSectionPopup, setIsAssignSectionPopup] = useState(false);
  const [isAddUserPopup, setIsAddUserPopup] = useState(false);
  const [cardProgress, setCardProgress] = useState({});
  const [cardBuyData, setCardBuyData] = useState({});
  const [isgraphData, setIsgraphData] = useState(false);
  const HandleCardProgress = (name, value) => {
    let tmpObj = { ...cardProgress, [name]: value };
    setCardProgress(tmpObj);
  };

  // console.log(cardBuyData?.buy1);
  const HandleBuyData = (name, value) => {
    let tmpObj = { ...cardBuyData, [name]: value };
    setCardBuyData(tmpObj);
  };

  if (cardBuyData?.buy1 == true) {
    // window.location = "/cartmat-Full-Maturity-Assessment";
    return <Redirect to="/cartmat-Full-Maturity-Assessment" />;
  }
  if (cardBuyData.buy2 == true) {
    // window.location = "/cartmat-Buy-Loss-Anaylysis";
    return <Redirect to="/cartmat-Buy-Loss-Anaylysis" />;
  }
  if (cardBuyData.buy3 == true) {
    window.location = "/training-courses";
  }

  const user = JSON.parse(localStorage.getItem("userData"));

  const usermail = user ? user.email : 0;
  const usid = user ? user.uid : 0;

  const [PaymentStatus, setPaymentStatus] = useState([]);
  const [MaturityPaymentStatus, setMaturityPaymentStatus] = useState([]);
  const [LossAnalysisPaymentStatus, setLossAnalysisPaymentStatus] = useState(
    []
  ); 
  const [BuyBothPaymentStatus, setBuyBothPaymentStatus] = useState([]);
  const [UserData, setUserData] = useState([]);
  const [UserPlantCheck, setUserPlantCheck] = useState([]);
  const [PlantDeatils, setPlantDeatils] = useState([]);
  const [InvitedUserCheck, setInvitedUserCheck] = useState([]);
  const [InvitedUserCheckLoss, setInvitedUserCheckLoss] = useState([]);
  const [PlantIdCheckLoss, setPlantIdCheckLoss] = useState();
  const [indexscore, setIndexScore] = useState();
  const [progress, setProgress] = useState();

  const [lossProgress, setLossProgress] = useState(false);

  // console.log(InvitedUserCheckLoss);
  //console.log(PlantIdCheckLoss);
  let pit = 0;
  if (props.catpr) {
    let sum = 0;

    for (let i = 0; i < props.catpr.length; i++) {
      sum += props.catpr[i].catprog;
    }
    let count = props.catpr.length;
    let totalsum = sum;
    let calcperc = (totalsum / (count * 100)) * 100;
   // console.log(calcperc);
    pit = Math.round(calcperc);
  }

  useEffect(() => {
    loadPaymentStatus();
    loadMaturityPaymentStatus();
    loadLossAnalysisPaymentStatus();
    //loadAssessmentUser();
    loadCheckUserPlant();
    loadsetPlantDeatils();
    loadCheckInvitedUser();
    loadCheckInvitedUserForLoss();
    buybothPaymentStatus();
    
   
  }, []);
  // const plantid = PlantDeatils.id;
  const loadPaymentStatus = async () => {
    const result1 = await serviceProvider.get(
      `/plants/payment_status?user_id=${usid}&type=training`,true,{}
    );
    setPaymentStatus(result1.data);
  };
  const loadMaturityPaymentStatus = async () => {
    const result2 = await serviceProvider.get(
      `/plants/payment_status?user_id=${usid}&type=maturity`,true,{}
    );
    setMaturityPaymentStatus(result2.data);
  };
  const loadLossAnalysisPaymentStatus = async () => {
    const result3 = await serviceProvider.get(
      `/plants/payment_status?user_id=${usid}&type=lossanalysis`,true,{}
    );
    setLossAnalysisPaymentStatus(result3.data);
  };

  const buybothPaymentStatus = async () => {
    const result4 = await serviceProvider.get(
      `/plants/payment_status?user_id=${usid}&type=buybothpayments`,true,{}
    );
    setBuyBothPaymentStatus(result4.data);
  };

  const loadAssessmentUser = async () => {
    const result4 = await serviceProvider.get(
      `/plants/totalUser?user_id=${usid}&type=assessmentUser`
    );
    setUserData(result4.data[0]);
  };
  const loadCheckUserPlant = async () => {
    const result5 = await serviceProvider.get(
      `/plants/CheckUserPlant?user_id=${usid}`
    );

    setUserPlantCheck(result5.data);
  };

  const loadsetPlantDeatils = async () => {
    const result6 = await serviceProvider.get(
      `/plants/PlantDetails?user_id=${usid}`,true,{}
    );
    setPlantDeatils(result6.data[0]);
    if (!isEmptyObject(result6.data)) {
      const result9 = await serviceProvider.get(
        `/plants/CheckLineSetup?plant_id=${result6.data[0].id}`,true,{}
      );
      setPlantIdCheckLoss(result9.data);
      const result10 = await serviceProvider.get(
        `/plants/indexscore?plant_id=${result6.data[0].id}`,true,{}
      );
      setIndexScore(result10.data);
      const result11 = await serviceProvider.get(
        `/home?param=totalprogress&pid=${result6.data[0].id}`,true,{}
      );
      setProgress(result11.data[0].progress);

      const result12 = await serviceProvider.get(
        `/home?param=progresscheck&uid=${usid}&pid=${result6.data[0].id}`,true,{}
      );
      //  const data3 = result7.data;
      // console.log(result12.data[0]);
      //  setCatprogress(data3);
    }
  };

  const loadCheckInvitedUser = async () => {
    const result7 = await serviceProvider.get(
      `/plants/CheckInvitedUser?user_id=${usid}`,true,{}
    );
    // console.log(result7.data);
    setInvitedUserCheck(result7.data);
  };

  const loadCheckInvitedUserForLoss = async () => {
    const result8 = await serviceProvider.get(
      `/plants/CheckInvitedUserForLoss?user_id=${usid}`,true,{}
    );
    setInvitedUserCheckLoss(result8.data);
  };

  

  const lossdashboard = (e) => {
    window.location = `/loss-analysis-admin/section/${PlantDeatils.plant_slug}`;
  };
  const lossdashboard1 = (e) => {
    window.location.assign(`/loss-analysis-setup/${PlantDeatils.plant_slug}`);
  };
  const DrawGraph = (id) => {
    const keys = Object.keys(data[0]).slice(1);
    const tip = d3tip()
      .attr("class", "md-d3-tip")
      .html((EVENT, d) => d);
    // const tip = '';
    const barwidth = 12;
    const margin = {
      top: 30,
      right: 20,
      bottom: 20,
      left: 40,
      barMargin: 25,
    };
    let width;
    // width according to screen width
    if (window.innerWidth > 1200) {
      if (data.length > 14) {
        width =
          barwidth * 3 * data.length +
          data.length * margin.barMargin * 2 +
          margin.barMargin * 2.5;
      } else {
        width = document.getElementById(id).offsetWidth;
      }
    } else if (window.innerWidth >= 1000 && window.innerWidth < 1200) {
      if (data.length > 10) {
        width =
          barwidth * 3 * data.length +
          data.length * margin.barMargin * 2 +
          margin.barMargin * 2.5;
      } else {
        width = document.getElementById(id).offsetWidth - 5;
      }
    } else if (window.innerWidth >= 750 && window.innerWidth < 1000) {
      if (data.length > 7) {
        width =
          barwidth * 3 * data.length +
          data.length * margin.barMargin * 2 +
          margin.barMargin * 2.5;
      } else {
        width = document.getElementById(id).offsetWidth - 5;
      }
    } else {
      width =
        barwidth * 3 * data.length +
        data.length * margin.barMargin * 2 +
        margin.barMargin * 2.5;
    }
    // width according to screen width end
    let height = 200,
      innerWidth = width - margin.left - margin.right,
      innerHeight = height - margin.top - margin.bottom,
      svg = d3
        .select(`#${id}`)
        .append("svg")
        .attr("width", width)
        .attr("height", height);
    let g = svg
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);
    svg.call(tip);
    const x0 = d3.scaleBand().rangeRound([0, innerWidth]).paddingInner(0.1);

    const x1 = d3.scaleBand().padding(0.05);

    const y = d3.scaleLinear().rangeRound([innerHeight, 0]);

    const z = d3.scaleOrdinal().range(["#7DB9FF", "#EF6C00", "#45B097"]);

    x0.domain(data.map((d) => d.week));
    x1.domain(keys).rangeRound([0, x0.bandwidth()]);
    y.domain([0, d3.max(data, (d) => d3.max(keys, (key) => d[key]))]).nice();

    //draw grid lines-----

    g.append("path")
      .attr("d", `M0 -5 L0 ${innerHeight}`)
      .attr("stroke", "#CBCFD2");

    g.append("g")
      .attr("class", "grid")
      .call(
        d3
          .axisLeft(y)
          .scale(y)
          .ticks(5)
          .tickSize(-innerWidth, 0, 0)
          .tickFormat("")
      )
      .attr("color", "#CBCFD2")
      .attr("stroke-dasharray", "2 2");

    //left axis text-----
    g.append("g")
      .attr("color", "#CBCFD2")
      .attr("class", "axis-left")
      .call(d3.axisLeft(y).ticks(5))
      .append("text")
      .attr("x", 10)
      .attr("y", y(y.ticks().pop()) + 20)
      .attr("dy", "0.32em")
      .style("transform", "rotate(-90deg)")
      .attr("font-weight", "bold")
      .attr("text-anchor", "end");

    //bottom texts
    g.append("g")
      .attr("transform", `translate(${margin.barMargin} ,0)`)
      .selectAll("g")
      .data(data)
      .enter()
      .append("text")
      .text((d) => d["week"])
      .attr(
        "transform",
        (d, index) =>
          `translate(${(barwidth + margin.barMargin * 3) * index} ,${
            innerHeight + 15
          })`
      )
      .attr("fill", "#a6a7ad");

    //draw bars-----
    g.append("g")
      .attr("transform", `translate(${margin.barMargin} ,0)`)
      .selectAll("g")
      .data(data)
      .enter()
      .append("g")
      .attr(
        "transform",
        (d, index) =>
          `translate(${(barwidth + margin.barMargin * 3) * index} ,0)`
      )
      .selectAll("rect")
      .data((d) =>
        keys.map((key) => {
          return { key: key, value: d[key] };
        })
      )
      .enter()
      .append("rect")
      .attr("x", (d, index) => barwidth * index)
      .attr("y", (d) => {
        if (d.value) {
          return y(d.value);
        } else {
          return innerHeight - 0.5;
        }
      })
      .attr("width", barwidth)
      .attr("height", (d) => {
        if (d.value) {
          return innerHeight - y(d.value) + 0.5;
        } else {
          return 1;
        }
      })
      .attr("fill", (d) => z(d.key))
      .attr("stroke", (d) => z(d.key))
      .on("mouseover", (event, d) => {
        const element = `<span>${d.value}%</span>`;
        tip.show(event, element);
      })
      .on("mouseout", tip.hide);
  };
  useEffect(() => {
    DrawGraph("graphDiv");
  }, []);
  function redirectNewTab(e) {
    e.preventDefault();
    if (InvitedUserCheck) {
      window.location.assign(`/assessment/${PlantDeatils.plant_slug}`);
    }
  }
  function redirectLossAnalysis(e) {
    e.preventDefault();
    if ((LossAnalysisPaymentStatus || BuyBothPaymentStatus) && UserPlantCheck) {
      if ( PlantIdCheckLoss == 1) {
        window.location = `/loss-analysis-admin/section/${PlantDeatils.plant_slug}`;
      } else {
        window.location.assign(
          `/loss-analysis-setup/${PlantDeatils.plant_slug}`
        );
      }
    }
  }
  const [asspopup, setAssPopup] = useState([]);
  const openAssPopup = (e) => {
    const getVal = $(e.target).attr("data-id");
    setAssPopup(getVal);

    setIsAssignSectionPopup(true);
  };

  let { addProduct, cartItems, increase } = useContext(CartContext);

  return (
    <>
      {/* Maturity Assessment Dashboard start */}
      {/* Maturity Assessment Dashboard First Screen */}
      <div className="maturity-admin-dashboard-wrapper">
        <div className="maturity-assessment-page-row">
          <div className="maturity-assessment-col md-col-6 mb-32">
            <div className="user-card-wrapper">
              <div className="user-card-row">
                <div className="user-card-col md-col mb-32">
                  <div className="user-card">
                    <div className="card-body">
                      <div className="text-div">
                        <h2 className="card-heading">Total Plant User</h2>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="left-sec img-box">
                        <span className="cir">
                          <img
                            src={
                              require("../../assets/img/maturity-dashboard-adm/user.svg")
                                .default
                            }
                            alt="User"
                          />
                        </span>
                      </div>
                      <div className="right-sec num-box">
                        <span className="user-num">{asu.totalUser}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="user-card-col md-col mb-32"
                  onClick={redirectNewTab}
                  style={{
                    cursor:
                      (UserPlantCheck || InvitedUserCheck) &&
                      MaturityPaymentStatus != 0
                        ? "pointer"
                        : "default",
                  }}
                >
                  <div className="user-card">
                    <div className="card-body">
                      <div className="text-div">
                        <h2 className="card-heading blue">
                          Maturity Assessment User
                        </h2>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div
                        className="left-sec button-wrap"
                        style={{
                          display: cardProgress.progress1 || InvitedUserCheck ? "none" : "",
                        }}
                      >
                        {!MaturityPaymentStatus && !BuyBothPaymentStatus ? (
                          <Link
                            to="/cartmat-Full-Maturity-Assessment"
                            onClick={() => addProduct(matdata)}
                            className="buy-now-link"
                          >
                            + Buy Now
                          </Link>
                        ) : // <a href="/cartmat-Full-Maturity-Assessment" onClick={() => addProduct(matdata)} className="buy-now-link" >+ Buy Now</a>
                        !UserPlantCheck ? (
                          <button
                            className="btn-link start"
                            onClick={() => setIsAddUserPopup(true)}
                          >
                            Add Users
                          </button>
                        ) : InvitedUserCheck ? (
                          " "
                        ) : (
                          <button
                            className="btn-link start"
                            data-id="MaturityPopup"
                            onClick={(e) => openAssPopup(e)}
                          >
                            Add Users
                          </button>
                        )}
                      </div>
                      {!InvitedUserCheck ? (
                        " "
                      ) : (
                        <div className="left-sec progress-bar">
                          <Progress
                            value={progress ? progress : 0}
                            color="blue"
                          />
                        </div>
                      )}

                      <div className="right-sec num-box">
                        <span className="user-num">{asu.assessment_user}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user-card-col md-col">
                  <div className="user-card">
                    <div className="card-body">
                      <div
                        className="text-div"
                        onClick={redirectLossAnalysis}
                        style={{
                          cursor:
                            (UserPlantCheck || PlantIdCheckLoss == 1) &&
                            LossAnalysisPaymentStatus != 0 || BuyBothPaymentStatus!=0
                              ? "pointer"
                              : "default",
                        }}
                      >
                        <h2 className="card-heading orange">
                          Loss Analysis User
                        </h2>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div
                        className="left-sec butdton-wrap md-progbar-loss"
                        style={{
                          display: cardProgress.progress2 ? "none" : "",
                        }}
                      >
                        {
                          !LossAnalysisPaymentStatus && !BuyBothPaymentStatus ? (
                            <Link
                              to="/cartmat-Loss-Analysis"
                              onClick={() => addProduct(losspdata)}
                              className="buy-now-link"
                            >
                              + Buy Now
                            </Link>
                          ) : !UserPlantCheck ? (
                            <button
                              className="btn-link start"
                              onClick={() => setIsAddUserPopup(true)}
                            >
                              Add Users
                            </button>
                          ) : InvitedUserCheckLoss == 1  &&
                            PlantIdCheckLoss == 1 ? (
                            // <button
                            //   className="btn-link start"
                            //   data-id="LossPopup"
                            //   onClick={(e) => lossdashboard(e)}
                            // >
                            //   Goto Dashboard
                            // </button>
                            <div className="left-sec progress-bar progbar-loss" onClick={(e) =>lossdashboard(e)}>
                            <Progress value={lossprogadmin?lossprogadmin:0} color="green" />
                          </div>
                          ) : UserPlantCheck && InvitedUserCheckLoss == 0 ? (
                            <button
                              className="btn-link start"
                              onClick={() => openAssPopup(true)}
                            >
                              Add Users
                            </button>
                          ) : (
                            ""
                          )
                          // <button className="btn-link start" data-id="LossPopup"
                          // onClick={(e) =>lossdashboard1(e)}
                          // >Goto Dashboard</button>
                          // <div className="left-sec progress-bar" onClick={(e) =>lossdashboard1(e)}>
                          // <Progress value={progress? progress : 0} color="blue" />
                          // </div>
                        }
                      </div>

                      {
                        !LossAnalysisPaymentStatus && !BuyBothPaymentStatus ? (
                          ""
                        ) : !UserPlantCheck ? (
                          ""
                        ) : InvitedUserCheckLoss == 1 &&
                          PlantIdCheckLoss == 1 ? (
                          ""
                        ) : UserPlantCheck && InvitedUserCheckLoss == 0 ? (
                          ""
                        ) : (
                          <div className="left-sec progress-bar" onClick={(e) =>lossdashboard1(e)}>
                            <Progress value={lossprogadmin?lossprogadmin:0} color="green" />
                          </div>
                        )
                        
                      }

                      <div className="right-sec num-box">
                        <span className="user-num">{asu.lossanalysisUser}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="user-card-col md-col">
                  <div className="user-card">
                    <div className="card-body">
                      <div className="text-div">
                        <h2 className="card-heading green">Training User</h2>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div
                        className="left-sec button-wrap"
                        style={{
                          display: cardProgress.progress3 ? "none" : "",
                        }}
                      >
                        {!PaymentStatus ? (
                          <button
                            className="buy-now-link"
                            onClick={() => HandleBuyData("buy3", true)}
                          >
                            + Buy Now
                          </button>
                        ) : (
                          // !UserPlantCheck ?
                          // <button className="btn-link start"
                          //   onClick={() => setIsAddUserPopup(true)}
                          // >Add Users</button>
                          <button
                            className="btn-link start"
                            onClick={() =>
                              (window.location = "/training-courses")
                            }
                          >
                            Goto Training
                          </button>
                        )}
                      </div>
                      <div
                        className="left-sec progress-bar"
                        style={{
                          display: !cardProgress.progress3 ? "none" : "",
                        }}
                      >
                        <Progress value={10} color="orange" />
                      </div>
                      {/* <div className="right-sec num-box">
                        <span className="user-num">{asu.trainingUser}</span>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="maturity-assessment-col md-col-6 mb-32">
            <div className="dashboard-top-tab">
              <span className="tab-type-btn yellow">
                <p>
                  <img
                    src={
                      require("../../assets/img/maturity-dashboard-adm/plant.svg")
                        .default
                    }
                    alt="true"
                  />
                  <span>Plants</span>
                </p>
                <div className="maturity-d-rgt-action-icon">
                  <div className="ms-maturity-d-more">
                    <button className="btn-dots">
                      <svg
                        width="4"
                        height="16"
                        viewBox="0 0 4 16"
                        className="maturity-d-more-icon"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
                          fill="#78909C"
                        />
                      </svg>
                    </button>
                  </div>

                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    className="maturity-d-toggle-icon"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 2.83L8.17 6L9.58 4.59L5 0L0.410004 4.59L1.83 6L5 2.83ZM5 15.17L1.83 12L0.420004 13.41L5 18L9.59 13.41L8.17 12L5 15.17Z"
                      fill="#78909C"
                    />
                  </svg>
                </div>
              </span>
            </div>
            <div className="maturity-plant-row">
              <div className="maturity-plant-col left-col">
                <div className="text-div">
                  <h2 className="plant-name">
                    {PlantDeatils ? PlantDeatils.plant_name : "Plant Name"}
                  </h2>
                  <div className="location-div">
                    <span>
                      {PlantDeatils
                        ? PlantDeatils.city_name + ", " + PlantDeatils.country
                        : "Location"}
                      {/* {PlantDeatils.city_name}, {PlantDeatils.country} */}
                    </span>
                    <address>
                      {PlantDeatils ? PlantDeatils.plant_size : ""} FTE
                    </address>
                  </div>
                </div>
              </div>
              <div className="maturity-plant-col right-col">
                <div className="result-card-wrap">
                  <div className="card-body">
                    <h4 className="heading-txt maturity">
                      Maturity Assessment Result
                    </h4>
                    <div className="result-text">
                      <span className="head-txt">Index Score:</span>
                      <span className="value">
                        {indexscore > 0 ? indexscore : 0}%
                      </span>
                      <span className="cir-img"></span>
                    </div>
                    <div className="note">
                      <em>
                        {indexscore > 0 ? (
                          <button className="view-link-res">
                            + View full results
                          </button>
                        ) : (
                          `No Data Yet`
                        )}
                      </em>
                    </div>
                    {/* <button className="view-link-res">+ View full results</button> */}
                  </div>
                </div>
              </div>
              <div className="maturity-plant-col left-col">
                <div className="text-div">
                  <h3>Plant Admin:</h3>
                  <div className="link-wrap">
                    {!PlantDeatils ? (
                      <button
                        className="setup-link link"
                        title="Setup Plant"
                        onClick={() => setIsAddPlantPopup(true)}
                        style={{ display: "none" }}
                      >
                        + Setup Plant
                      </button>
                    ) : (
                      <span className="setup-user">
                        {PlantDeatils.name} {PlantDeatils.surname}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="maturity-plant-col right-col">
                <div className="result-card-wrap">
                  <div className="card-body">
                    <h4 className="heading-txt loss">Loss Analysis Result</h4>
                    <div className="result-text">
                      <span className="head-txt">Total Losses Identified:</span>
                      <span className="value">$</span>
                    </div>
                    <div className="note">
                      <em>No Data Yet</em>
                    </div>
                    {/* <div className="note" style={{ display: 'none' }}><em>No Data Yet</em></div> */}
                    {/* <button className="view-link-res">+ View full results</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="maturity-assessment-col md-col-12">
            <div className="dashboard-top-tab">
              <span className={`tab-type-btn ${isgraphData ? "grey" : "blue"}`}>
                <p>
                  <span>Plant Work Progress</span>
                </p>
                <div className="maturity-d-rgt-action-icon">
                  <div className="ms-maturity-d-more">
                    <button className="btn-dots">
                      <svg
                        width="4"
                        height="16"
                        viewBox="0 0 4 16"
                        className="maturity-d-more-icon"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"
                          fill="#78909C"
                        />
                      </svg>
                    </button>
                  </div>

                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    className="maturity-d-toggle-icon"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 2.83L8.17 6L9.58 4.59L5 0L0.410004 4.59L1.83 6L5 2.83ZM5 15.17L1.83 12L0.420004 13.41L5 18L9.59 13.41L8.17 12L5 15.17Z"
                      fill="#78909C"
                    />
                  </svg>
                </div>
              </span>
            </div>
            <div className="maturity-graph-row">
              <div className="no-data-graph">
                {isgraphData ? (
                  <TmpGraphSvg />
                ) : (
                  <div className="md-graph-div" style={{ width: "100%" }}>
                    <div className="labels-wrapper">
                      <label className="blue">Maturity Assessment</label>
                      <label className="orange">Loss Analysis</label>
                      <label className="green">Training</label>
                    </div>
                    <div id="graphDiv" className="graph-wrapper"></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* overview */}
        <MaturityOverView openAssignPopup={setIsAssignSectionPopup} />
      </div>
      {/*--------------------- admin all popups---------------- */}
      {/*---popups----*/}
      <MaturityPlantSetupPopup
        open={isAddPlantPopup}
        setOpen={setIsAddPlantPopup}
        {...props}
      />
      <MaturitySubmitDataPopup
        open={isSubmitDataPopup}
        setOpen={setIsSubmitDataPopup}
        {...props}
      />
      <AssignSectionPopup
        open={isAssignSectionPopup}
        setOpen={setIsAssignSectionPopup}
        assessmentPopup={asspopup}
        {...props}
      />
      <MaturityAddUserPopup
        open={isAddUserPopup}
        setOpen={setIsAddUserPopup}
        setAddPlantPopup={setIsAddPlantPopup}
        {...props}
      />
    </>
  );
};

const Progress = ({ value, color }) => {
  return (
    <>
      <span className="mssg">
        {value < 100 && value > 0
          ? "In Progress"
          : value === 100
          ? "Completed"
          : "Not Started"}{" "}
        ({value ? value : "0"}%)
      </span>
      <div className="progress">
        <div className={`bar ${color}`} style={{ width: `${value}%` }}></div>
      </div>
    </>
  );
};

function TmpGraphSvg() {
  return (
    <svg viewBox="0 0 1312 301" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width={1311} height={300} fill="white" />
      <line x1="31.5" y1={55} x2="31.5" y2={248} stroke="#CBCFD2" />
      <line
        x1={1288}
        y1="211.5"
        x2={31}
        y2="211.5"
        stroke="#CBCFD2"
        strokeDasharray="2 2"
      />
      <line
        x1={1288}
        y1="175.5"
        x2={31}
        y2="175.5"
        stroke="#CBCFD2"
        strokeDasharray="2 2"
      />
      <line
        x1={1288}
        y1="139.5"
        x2={31}
        y2="139.5"
        stroke="#CBCFD2"
        strokeDasharray="2 2"
      />
      <line
        x1={1288}
        y1="103.5"
        x2={31}
        y2="103.5"
        stroke="#CBCFD2"
        strokeDasharray="2 2"
      />
      <line
        x1={1288}
        y1="67.5"
        x2={31}
        y2="67.5"
        stroke="#CBCFD2"
        strokeDasharray="2 2"
      />
      <path
        d="M24.875 248.099C26.4801 248.099 27.4034 246.739 27.4034 244.364C27.4034 242.006 26.4659 240.628 24.875 240.628C23.2841 240.628 22.3466 242.006 22.3466 244.364C22.3466 246.739 23.2699 248.099 24.875 248.099ZM24.875 247.318C23.8168 247.318 23.1989 246.256 23.1989 244.364C23.1989 242.474 23.8239 241.395 24.875 241.395C25.9261 241.395 26.5511 242.474 26.5511 244.364C26.5511 246.256 25.9332 247.318 24.875 247.318Z"
        fill="#A6A7AD"
      />
      <path
        d="M16.5482 215H21.1362V214.219H17.7555V214.162L19.3891 212.415C20.6391 211.076 21.0084 210.451 21.0084 209.645C21.0084 208.523 20.0993 207.628 18.8209 207.628C17.546 207.628 16.5766 208.494 16.5766 209.773H17.4146C17.4146 208.945 17.9509 208.395 18.7925 208.395C19.5808 208.395 20.1845 208.878 20.1845 209.645C20.1845 210.316 19.7903 210.813 18.9487 211.733L16.5482 214.361V215ZM24.875 215.099C26.4801 215.099 27.4034 213.739 27.4034 211.364C27.4034 209.006 26.4659 207.628 24.875 207.628C23.2841 207.628 22.3466 209.006 22.3466 211.364C22.3466 213.739 23.2699 215.099 24.875 215.099ZM24.875 214.318C23.8168 214.318 23.1989 213.256 23.1989 211.364C23.1989 209.474 23.8239 208.395 24.875 208.395C25.9261 208.395 26.5511 209.474 26.5511 211.364C26.5511 213.256 25.9332 214.318 24.875 214.318Z"
        fill="#A6A7AD"
      />
      <path
        d="M16.0164 177.509H19.4397V179H20.2777V177.509H21.2721V176.727H20.2777V171.727H19.2124L16.0164 176.784V177.509ZM19.4397 176.727H16.9681V176.67L19.3828 172.849H19.4397V176.727ZM24.875 179.099C26.4801 179.099 27.4034 177.739 27.4034 175.364C27.4034 173.006 26.4659 171.628 24.875 171.628C23.2841 171.628 22.3466 173.006 22.3466 175.364C22.3466 177.739 23.2699 179.099 24.875 179.099ZM24.875 178.318C23.8168 178.318 23.1989 177.256 23.1989 175.364C23.1989 173.474 23.8239 172.395 24.875 172.395C25.9261 172.395 26.5511 173.474 26.5511 175.364C26.5511 177.256 25.9332 178.318 24.875 178.318Z"
        fill="#A6A7AD"
      />
      <path
        d="M18.7774 143.099C20.2476 143.117 21.2064 142.009 21.2064 140.656C21.2064 139.25 20.1659 138.241 18.9194 138.241C18.1701 138.241 17.5274 138.607 17.1297 139.207H17.0728C17.0764 137.435 17.7653 136.409 18.891 136.409C19.6581 136.409 20.1197 136.892 20.2831 137.545H21.1495C20.972 136.416 20.1126 135.628 18.891 135.628C17.2539 135.628 16.249 137.077 16.249 139.648C16.249 142.336 17.5842 143.085 18.7774 143.099ZM18.7774 142.318C17.8647 142.318 17.1971 141.54 17.2007 140.67C17.2042 139.8 17.9038 139.023 18.8058 139.023C19.6971 139.023 20.3541 139.754 20.3541 140.656C20.3541 141.58 19.6687 142.318 18.7774 142.318ZM24.875 143.099C26.4801 143.099 27.4034 141.739 27.4034 139.364C27.4034 137.006 26.4659 135.628 24.875 135.628C23.2841 135.628 22.3466 137.006 22.3466 139.364C22.3466 141.739 23.2699 143.099 24.875 143.099ZM24.875 142.318C23.8168 142.318 23.1989 141.256 23.1989 139.364C23.1989 137.474 23.8239 136.395 24.875 136.395C25.9261 136.395 26.5511 137.474 26.5511 139.364C26.5511 141.256 25.9332 142.318 24.875 142.318Z"
        fill="#A6A7AD"
      />
      <path
        d="M18.7703 107.099C20.2227 107.099 21.2348 106.251 21.2419 105.068C21.2348 104.148 20.6204 103.367 19.8356 103.222V103.179C20.5174 103.001 20.9649 102.334 20.972 101.56C20.9649 100.452 20.0345 99.6278 18.7703 99.6278C17.4919 99.6278 16.5615 100.452 16.5686 101.56C16.5615 102.334 17.0089 103.001 17.7049 103.179V103.222C16.9059 103.367 16.2916 104.148 16.2987 105.068C16.2916 106.251 17.3037 107.099 18.7703 107.099ZM18.7703 106.318C17.7724 106.318 17.1581 105.807 17.1652 105.026C17.1581 104.205 17.8363 103.619 18.7703 103.619C19.69 103.619 20.3683 104.205 20.3754 105.026C20.3683 105.807 19.7539 106.318 18.7703 106.318ZM18.7703 102.866C17.9748 102.866 17.4137 102.369 17.4208 101.616C17.4137 100.878 17.9535 100.395 18.7703 100.395C19.5728 100.395 20.1126 100.878 20.1197 101.616C20.1126 102.369 19.5515 102.866 18.7703 102.866ZM24.875 107.099C26.4801 107.099 27.4034 105.739 27.4034 103.364C27.4034 101.006 26.4659 99.6278 24.875 99.6278C23.2841 99.6278 22.3466 101.006 22.3466 103.364C22.3466 105.739 23.2699 107.099 24.875 107.099ZM24.875 106.318C23.8168 106.318 23.1989 105.256 23.1989 103.364C23.1989 101.474 23.8239 100.395 24.875 100.395C25.9261 100.395 26.5511 101.474 26.5511 103.364C26.5511 105.256 25.9332 106.318 24.875 106.318Z"
        fill="#A6A7AD"
      />
      <path
        d="M14.3612 63.7273H13.4805L11.6624 64.9347V65.8295L13.4379 64.6506H13.4805V71H14.3612V63.7273ZM18.725 71.0994C20.3301 71.0994 21.2534 69.7393 21.2534 67.3636C21.2534 65.0057 20.3159 63.6278 18.725 63.6278C17.1341 63.6278 16.1966 65.0057 16.1966 67.3636C16.1966 69.7393 17.1199 71.0994 18.725 71.0994ZM18.725 70.3182C17.6668 70.3182 17.0489 69.2564 17.0489 67.3636C17.0489 65.4744 17.6739 64.3949 18.725 64.3949C19.7761 64.3949 20.4011 65.4744 20.4011 67.3636C20.4011 69.2564 19.7832 70.3182 18.725 70.3182ZM24.875 71.0994C26.4801 71.0994 27.4034 69.7393 27.4034 67.3636C27.4034 65.0057 26.4659 63.6278 24.875 63.6278C23.2841 63.6278 22.3466 65.0057 22.3466 67.3636C22.3466 69.7393 23.2699 71.0994 24.875 71.0994ZM24.875 70.3182C23.8168 70.3182 23.1989 69.2564 23.1989 67.3636C23.1989 65.4744 23.8239 64.3949 24.875 64.3949C25.9261 64.3949 26.5511 65.4744 26.5511 67.3636C26.5511 69.2564 25.9332 70.3182 24.875 70.3182Z"
        fill="#A6A7AD"
      />
      <circle cx={500} cy={36} r={6} fill="#7DB9FF" />
      <path
        d="M515.057 31.2727V40H516.045V33.3693H516.131L518.858 40H519.812L522.54 33.3693H522.625V40H523.614V31.2727H522.352L519.386 38.517H519.284L516.318 31.2727H515.057ZM527.402 40.1534C528.544 40.1534 529.141 39.5398 529.346 39.1136H529.397V40H530.402V35.6875C530.402 33.608 528.817 33.3693 527.982 33.3693C526.993 33.3693 525.868 33.7102 525.357 34.9034L526.311 35.2443C526.533 34.767 527.057 34.2557 528.016 34.2557C528.941 34.2557 529.397 34.7457 529.397 35.5852V35.6193C529.397 36.1051 528.902 36.0625 527.709 36.2159C526.495 36.3736 525.169 36.642 525.169 38.142C525.169 39.4205 526.158 40.1534 527.402 40.1534ZM527.556 39.25C526.755 39.25 526.175 38.892 526.175 38.1932C526.175 37.4261 526.874 37.1875 527.658 37.0852C528.084 37.0341 529.226 36.9148 529.397 36.7102V37.6307C529.397 38.4489 528.749 39.25 527.556 39.25ZM534.965 33.4545H533.567V31.8864H532.561V33.4545H531.573V34.3068H532.561V38.3977C532.561 39.5398 533.482 40.0852 534.334 40.0852C534.709 40.0852 534.948 40.017 535.084 39.9659L534.879 39.0625C534.794 39.0795 534.658 39.1136 534.436 39.1136C533.993 39.1136 533.567 38.9773 533.567 38.125V34.3068H534.965V33.4545ZM540.482 37.3239C540.482 38.5511 539.545 39.1136 538.795 39.1136C537.96 39.1136 537.363 38.5 537.363 37.5455V33.4545H536.357V37.6136C536.357 39.2841 537.244 40.0852 538.471 40.0852C539.46 40.0852 540.107 39.5568 540.414 38.892H540.482V40H541.488V33.4545H540.482V37.3239ZM543.21 40H544.216V35.858C544.216 34.9716 544.915 34.3239 545.869 34.3239C546.138 34.3239 546.415 34.375 546.483 34.392V33.3693C546.368 33.3608 546.103 33.3523 545.954 33.3523C545.17 33.3523 544.488 33.7955 544.25 34.4432H544.182V33.4545H543.21V40ZM547.555 40H548.561V33.4545H547.555V40ZM548.066 32.3636C548.458 32.3636 548.782 32.0568 548.782 31.6818C548.782 31.3068 548.458 31 548.066 31C547.674 31 547.35 31.3068 547.35 31.6818C547.35 32.0568 547.674 32.3636 548.066 32.3636ZM553.129 33.4545H551.731V31.8864H550.726V33.4545H549.737V34.3068H550.726V38.3977C550.726 39.5398 551.646 40.0852 552.498 40.0852C552.873 40.0852 553.112 40.017 553.248 39.9659L553.044 39.0625C552.959 39.0795 552.822 39.1136 552.601 39.1136C552.157 39.1136 551.731 38.9773 551.731 38.125V34.3068H553.129V33.4545ZM555.17 42.4545C556.077 42.4545 556.716 41.973 557.096 40.9545L559.883 33.4716L558.783 33.4545L556.976 38.6705H556.908L555.101 33.4545H554.01L556.431 40.0341L556.243 40.5455C555.877 41.5426 555.425 41.6364 554.692 41.4489L554.437 42.3352C554.539 42.3864 554.829 42.4545 555.17 42.4545ZM564.843 40L565.72 37.5284H569.249L570.127 40H571.235L568.03 31.2727H566.939L563.735 40H564.843ZM566.053 36.5909L567.451 32.6534H567.519L568.916 36.5909H566.053ZM576.974 34.9205C576.659 33.9915 575.951 33.3693 574.656 33.3693C573.275 33.3693 572.252 34.1534 572.252 35.2614C572.252 36.1648 572.789 36.7699 573.991 37.0511L575.082 37.3068C575.742 37.4602 576.054 37.7756 576.054 38.2273C576.054 38.7898 575.457 39.25 574.519 39.25C573.697 39.25 573.181 38.8963 573.002 38.1932L572.048 38.4318C572.282 39.544 573.198 40.1364 574.537 40.1364C576.058 40.1364 577.093 39.3054 577.093 38.1761C577.093 37.2642 576.522 36.6889 575.355 36.4034L574.383 36.1648C573.608 35.973 573.258 35.7131 573.258 35.2102C573.258 34.6477 573.855 34.2386 574.656 34.2386C575.534 34.2386 575.896 34.7244 576.071 35.1761L576.974 34.9205ZM583.124 34.9205C582.808 33.9915 582.101 33.3693 580.805 33.3693C579.425 33.3693 578.402 34.1534 578.402 35.2614C578.402 36.1648 578.939 36.7699 580.141 37.0511L581.231 37.3068C581.892 37.4602 582.203 37.7756 582.203 38.2273C582.203 38.7898 581.606 39.25 580.669 39.25C579.847 39.25 579.331 38.8963 579.152 38.1932L578.197 38.4318C578.432 39.544 579.348 40.1364 580.686 40.1364C582.207 40.1364 583.243 39.3054 583.243 38.1761C583.243 37.2642 582.672 36.6889 581.504 36.4034L580.533 36.1648C579.757 35.973 579.408 35.7131 579.408 35.2102C579.408 34.6477 580.004 34.2386 580.805 34.2386C581.683 34.2386 582.045 34.7244 582.22 35.1761L583.124 34.9205ZM587.381 40.1364C588.711 40.1364 589.682 39.4716 589.989 38.483L589.017 38.2102C588.762 38.892 588.169 39.233 587.381 39.233C586.201 39.233 585.387 38.4702 585.34 37.0682H590.091V36.642C590.091 34.2045 588.642 33.3693 587.279 33.3693C585.506 33.3693 584.33 34.767 584.33 36.7784C584.33 38.7898 585.489 40.1364 587.381 40.1364ZM585.34 36.1989C585.408 35.1804 586.128 34.2727 587.279 34.2727C588.37 34.2727 589.069 35.0909 589.069 36.1989H585.34ZM596.137 34.9205C595.822 33.9915 595.115 33.3693 593.819 33.3693C592.439 33.3693 591.416 34.1534 591.416 35.2614C591.416 36.1648 591.953 36.7699 593.154 37.0511L594.245 37.3068C594.906 37.4602 595.217 37.7756 595.217 38.2273C595.217 38.7898 594.62 39.25 593.683 39.25C592.86 39.25 592.345 38.8963 592.166 38.1932L591.211 38.4318C591.446 39.544 592.362 40.1364 593.7 40.1364C595.221 40.1364 596.257 39.3054 596.257 38.1761C596.257 37.2642 595.686 36.6889 594.518 36.4034L593.547 36.1648C592.771 35.973 592.422 35.7131 592.422 35.2102C592.422 34.6477 593.018 34.2386 593.819 34.2386C594.697 34.2386 595.059 34.7244 595.234 35.1761L596.137 34.9205ZM602.287 34.9205C601.972 33.9915 601.264 33.3693 599.969 33.3693C598.588 33.3693 597.565 34.1534 597.565 35.2614C597.565 36.1648 598.102 36.7699 599.304 37.0511L600.395 37.3068C601.055 37.4602 601.367 37.7756 601.367 38.2273C601.367 38.7898 600.77 39.25 599.832 39.25C599.01 39.25 598.494 38.8963 598.315 38.1932L597.361 38.4318C597.595 39.544 598.511 40.1364 599.849 40.1364C601.371 40.1364 602.406 39.3054 602.406 38.1761C602.406 37.2642 601.835 36.6889 600.668 36.4034L599.696 36.1648C598.92 35.973 598.571 35.7131 598.571 35.2102C598.571 34.6477 599.168 34.2386 599.969 34.2386C600.847 34.2386 601.209 34.7244 601.384 35.1761L602.287 34.9205ZM603.8 40H604.806V35.9091C604.806 34.9503 605.505 34.2727 606.289 34.2727C607.052 34.2727 607.584 34.7713 607.584 35.517V40H608.607V35.7386C608.607 34.8949 609.135 34.2727 610.056 34.2727C610.772 34.2727 611.385 34.652 611.385 35.6193V40H612.391V35.6193C612.391 34.081 611.564 33.3693 610.397 33.3693C609.459 33.3693 608.773 33.7997 608.437 34.4773H608.368C608.044 33.7784 607.473 33.3693 606.613 33.3693C605.76 33.3693 605.13 33.7784 604.857 34.4773H604.772V33.4545H603.8V40ZM616.854 40.1364C618.184 40.1364 619.155 39.4716 619.462 38.483L618.491 38.2102C618.235 38.892 617.643 39.233 616.854 39.233C615.674 39.233 614.86 38.4702 614.813 37.0682H619.564V36.642C619.564 34.2045 618.116 33.3693 616.752 33.3693C614.979 33.3693 613.803 34.767 613.803 36.7784C613.803 38.7898 614.962 40.1364 616.854 40.1364ZM614.813 36.1989C614.881 35.1804 615.601 34.2727 616.752 34.2727C617.843 34.2727 618.542 35.0909 618.542 36.1989H614.813ZM621.98 36.0625C621.98 34.9205 622.687 34.2727 623.65 34.2727C624.584 34.2727 625.15 34.8821 625.15 35.9091V40H626.156V35.8409C626.156 34.1705 625.265 33.3693 623.94 33.3693C622.951 33.3693 622.338 33.8125 622.031 34.4773H621.946V33.4545H620.974V40H621.98V36.0625ZM630.72 33.4545H629.323V31.8864H628.317V33.4545H627.328V34.3068H628.317V38.3977C628.317 39.5398 629.237 40.0852 630.09 40.0852C630.465 40.0852 630.703 40.017 630.84 39.9659L630.635 39.0625C630.55 39.0795 630.414 39.1136 630.192 39.1136C629.749 39.1136 629.323 38.9773 629.323 38.125V34.3068H630.72V33.4545Z"
        fill="#4D4D4F"
      />
      <circle cx={650} cy={36} r={6} fill="#EF6C00" />
      <path
        d="M665.057 40H670.17V39.0625H666.114V31.2727H665.057V40ZM674.21 40.1364C675.982 40.1364 677.175 38.7898 677.175 36.7614C677.175 34.7159 675.982 33.3693 674.21 33.3693C672.437 33.3693 671.244 34.7159 671.244 36.7614C671.244 38.7898 672.437 40.1364 674.21 40.1364ZM674.21 39.233C672.863 39.233 672.249 38.0739 672.249 36.7614C672.249 35.4489 672.863 34.2727 674.21 34.2727C675.556 34.2727 676.17 35.4489 676.17 36.7614C676.17 38.0739 675.556 39.233 674.21 39.233ZM683.227 34.9205C682.912 33.9915 682.204 33.3693 680.909 33.3693C679.528 33.3693 678.505 34.1534 678.505 35.2614C678.505 36.1648 679.042 36.7699 680.244 37.0511L681.335 37.3068C681.995 37.4602 682.307 37.7756 682.307 38.2273C682.307 38.7898 681.71 39.25 680.772 39.25C679.95 39.25 679.434 38.8963 679.255 38.1932L678.301 38.4318C678.535 39.544 679.451 40.1364 680.789 40.1364C682.311 40.1364 683.346 39.3054 683.346 38.1761C683.346 37.2642 682.775 36.6889 681.608 36.4034L680.636 36.1648C679.86 35.973 679.511 35.7131 679.511 35.2102C679.511 34.6477 680.108 34.2386 680.909 34.2386C681.787 34.2386 682.149 34.7244 682.324 35.1761L683.227 34.9205ZM689.377 34.9205C689.061 33.9915 688.354 33.3693 687.058 33.3693C685.678 33.3693 684.655 34.1534 684.655 35.2614C684.655 36.1648 685.192 36.7699 686.394 37.0511L687.484 37.3068C688.145 37.4602 688.456 37.7756 688.456 38.2273C688.456 38.7898 687.859 39.25 686.922 39.25C686.1 39.25 685.584 38.8963 685.405 38.1932L684.45 38.4318C684.685 39.544 685.601 40.1364 686.939 40.1364C688.46 40.1364 689.496 39.3054 689.496 38.1761C689.496 37.2642 688.925 36.6889 687.757 36.4034L686.786 36.1648C686.01 35.973 685.661 35.7131 685.661 35.2102C685.661 34.6477 686.257 34.2386 687.058 34.2386C687.936 34.2386 688.298 34.7244 688.473 35.1761L689.377 34.9205ZM694.639 40L695.517 37.5284H699.045L699.923 40H701.031L697.826 31.2727H696.736L693.531 40H694.639ZM695.849 36.5909L697.247 32.6534H697.315L698.713 36.5909H695.849ZM703.14 36.0625C703.14 34.9205 703.847 34.2727 704.81 34.2727C705.743 34.2727 706.31 34.8821 706.31 35.9091V40H707.316V35.8409C707.316 34.1705 706.425 33.3693 705.1 33.3693C704.111 33.3693 703.498 33.8125 703.191 34.4773H703.106V33.4545H702.134V40H703.14V36.0625ZM710.96 40.1534C712.102 40.1534 712.698 39.5398 712.903 39.1136H712.954V40H713.96V35.6875C713.96 33.608 712.374 33.3693 711.539 33.3693C710.551 33.3693 709.426 33.7102 708.914 34.9034L709.869 35.2443C710.09 34.767 710.615 34.2557 711.573 34.2557C712.498 34.2557 712.954 34.7457 712.954 35.5852V35.6193C712.954 36.1051 712.46 36.0625 711.267 36.2159C710.052 36.3736 708.727 36.642 708.727 38.142C708.727 39.4205 709.715 40.1534 710.96 40.1534ZM711.113 39.25C710.312 39.25 709.732 38.892 709.732 38.1932C709.732 37.4261 710.431 37.1875 711.215 37.0852C711.642 37.0341 712.784 36.9148 712.954 36.7102V37.6307C712.954 38.4489 712.306 39.25 711.113 39.25ZM716.681 31.2727H715.675V40H716.681V31.2727ZM719.051 42.4545C719.958 42.4545 720.598 41.973 720.977 40.9545L723.764 33.4716L722.664 33.4545L720.857 38.6705H720.789L718.982 33.4545H717.892L720.312 40.0341L720.125 40.5455C719.758 41.5426 719.306 41.6364 718.573 41.4489L718.318 42.3352C718.42 42.3864 718.71 42.4545 719.051 42.4545ZM729.611 34.9205C729.295 33.9915 728.588 33.3693 727.293 33.3693C725.912 33.3693 724.889 34.1534 724.889 35.2614C724.889 36.1648 725.426 36.7699 726.628 37.0511L727.719 37.3068C728.379 37.4602 728.69 37.7756 728.69 38.2273C728.69 38.7898 728.094 39.25 727.156 39.25C726.334 39.25 725.818 38.8963 725.639 38.1932L724.685 38.4318C724.919 39.544 725.835 40.1364 727.173 40.1364C728.695 40.1364 729.73 39.3054 729.73 38.1761C729.73 37.2642 729.159 36.6889 727.991 36.4034L727.02 36.1648C726.244 35.973 725.895 35.7131 725.895 35.2102C725.895 34.6477 726.491 34.2386 727.293 34.2386C728.17 34.2386 728.533 34.7244 728.707 35.1761L729.611 34.9205ZM731.124 40H732.13V33.4545H731.124V40ZM731.635 32.3636C732.027 32.3636 732.351 32.0568 732.351 31.6818C732.351 31.3068 732.027 31 731.635 31C731.243 31 730.919 31.3068 730.919 31.6818C730.919 32.0568 731.243 32.3636 731.635 32.3636ZM738.488 34.9205C738.173 33.9915 737.465 33.3693 736.17 33.3693C734.789 33.3693 733.766 34.1534 733.766 35.2614C733.766 36.1648 734.303 36.7699 735.505 37.0511L736.596 37.3068C737.256 37.4602 737.567 37.7756 737.567 38.2273C737.567 38.7898 736.971 39.25 736.033 39.25C735.211 39.25 734.695 38.8963 734.516 38.1932L733.562 38.4318C733.796 39.544 734.712 40.1364 736.05 40.1364C737.572 40.1364 738.607 39.3054 738.607 38.1761C738.607 37.2642 738.036 36.6889 736.869 36.4034L735.897 36.1648C735.121 35.973 734.772 35.7131 734.772 35.2102C734.772 34.6477 735.369 34.2386 736.17 34.2386C737.048 34.2386 737.41 34.7244 737.585 35.1761L738.488 34.9205Z"
        fill="#4D4D4F"
      />
      <circle cx={758} cy={36} r={6} fill="#7FCDBB" />
      <path
        d="M772.58 32.2102H775.324V40H776.381V32.2102H779.125V31.2727H772.58V32.2102ZM779.82 40H780.826V35.858C780.826 34.9716 781.525 34.3239 782.479 34.3239C782.748 34.3239 783.025 34.375 783.093 34.392V33.3693C782.978 33.3608 782.713 33.3523 782.564 33.3523C781.78 33.3523 781.098 33.7955 780.86 34.4432H780.792V33.4545H779.82V40ZM786.091 40.1534C787.233 40.1534 787.83 39.5398 788.034 39.1136H788.085V40H789.091V35.6875C789.091 33.608 787.506 33.3693 786.671 33.3693C785.682 33.3693 784.557 33.7102 784.046 34.9034L785 35.2443C785.222 34.767 785.746 34.2557 786.705 34.2557C787.629 34.2557 788.085 34.7457 788.085 35.5852V35.6193C788.085 36.1051 787.591 36.0625 786.398 36.2159C785.183 36.3736 783.858 36.642 783.858 38.142C783.858 39.4205 784.847 40.1534 786.091 40.1534ZM786.244 39.25C785.443 39.25 784.864 38.892 784.864 38.1932C784.864 37.4261 785.563 37.1875 786.347 37.0852C786.773 37.0341 787.915 36.9148 788.085 36.7102V37.6307C788.085 38.4489 787.438 39.25 786.244 39.25ZM790.807 40H791.812V33.4545H790.807V40ZM791.318 32.3636C791.71 32.3636 792.034 32.0568 792.034 31.6818C792.034 31.3068 791.71 31 791.318 31C790.926 31 790.602 31.3068 790.602 31.6818C790.602 32.0568 790.926 32.3636 791.318 32.3636ZM794.54 36.0625C794.54 34.9205 795.247 34.2727 796.21 34.2727C797.144 34.2727 797.71 34.8821 797.71 35.9091V40H798.716V35.8409C798.716 34.1705 797.825 33.3693 796.5 33.3693C795.511 33.3693 794.898 33.8125 794.591 34.4773H794.506V33.4545H793.534V40H794.54V36.0625ZM800.434 40H801.439V33.4545H800.434V40ZM800.945 32.3636C801.337 32.3636 801.661 32.0568 801.661 31.6818C801.661 31.3068 801.337 31 800.945 31C800.553 31 800.229 31.3068 800.229 31.6818C800.229 32.0568 800.553 32.3636 800.945 32.3636ZM804.167 36.0625C804.167 34.9205 804.874 34.2727 805.838 34.2727C806.771 34.2727 807.338 34.8821 807.338 35.9091V40H808.343V35.8409C808.343 34.1705 807.453 33.3693 806.127 33.3693C805.139 33.3693 804.525 33.8125 804.218 34.4773H804.133V33.4545H803.161V40H804.167V36.0625ZM812.703 42.5909C814.271 42.5909 815.533 41.875 815.533 40.1875V33.4545H814.561V34.4943H814.459C814.237 34.1534 813.828 33.3693 812.55 33.3693C810.896 33.3693 809.754 34.6818 809.754 36.6932C809.754 38.7386 810.947 39.8977 812.533 39.8977C813.811 39.8977 814.22 39.1477 814.442 38.7898H814.527V40.1193C814.527 41.2102 813.76 41.7045 812.703 41.7045C811.514 41.7045 811.096 41.0781 810.828 40.7159L810.027 41.2784C810.436 41.9645 811.241 42.5909 812.703 42.5909ZM812.669 38.9943C811.408 38.9943 810.76 38.0398 810.76 36.6761C810.76 35.3466 811.39 34.2727 812.669 34.2727C813.896 34.2727 814.544 35.2614 814.544 36.6761C814.544 38.125 813.879 38.9943 812.669 38.9943Z"
        fill="#4D4D4F"
      />
      <line x1={1288} y1="247.5" x2={31} y2="247.5" stroke="#CBCFD2" />
      <rect
        opacity="0.3"
        x={10}
        y={55}
        width={1292}
        height={212}
        rx={8}
        fill="#CBCFD2"
      />
      <path
        d="M604.684 154.909H602.325V163.832H602.21L596.048 154.909H593.926V168H596.297V159.083H596.406L602.574 168H604.684V154.909ZM611.358 168.192C614.235 168.192 616.063 166.165 616.063 163.129C616.063 160.087 614.235 158.054 611.358 158.054C608.482 158.054 606.654 160.087 606.654 163.129C606.654 166.165 608.482 168.192 611.358 168.192ZM611.371 166.338C609.779 166.338 608.999 164.919 608.999 163.123C608.999 161.327 609.779 159.888 611.371 159.888C612.937 159.888 613.717 161.327 613.717 163.123C613.717 164.919 612.937 166.338 611.371 166.338ZM626.85 168C630.838 168 633.204 165.533 633.204 161.442C633.204 157.364 630.838 154.909 626.939 154.909H622.414V168H626.85ZM624.785 165.948V156.961H626.805C629.464 156.961 630.851 158.444 630.851 161.442C630.851 164.452 629.464 165.948 626.735 165.948H624.785ZM638.09 168.198C639.63 168.198 640.551 167.476 640.973 166.651H641.049V168H643.274V161.429C643.274 158.834 641.158 158.054 639.285 158.054C637.22 158.054 635.635 158.974 635.124 160.764L637.284 161.071C637.514 160.4 638.166 159.825 639.298 159.825C640.372 159.825 640.96 160.374 640.96 161.339V161.378C640.96 162.043 640.263 162.075 638.531 162.26C636.626 162.464 634.804 163.033 634.804 165.245C634.804 167.175 636.217 168.198 638.09 168.198ZM638.691 166.498C637.725 166.498 637.035 166.057 637.035 165.207C637.035 164.318 637.808 163.947 638.844 163.8C639.451 163.717 640.666 163.564 640.966 163.321V164.478C640.966 165.571 640.084 166.498 638.691 166.498ZM650.413 158.182H648.476V155.83H646.162V158.182H644.769V159.972H646.162V165.43C646.15 167.278 647.492 168.185 649.231 168.134C649.889 168.115 650.343 167.987 650.592 167.904L650.202 166.095C650.074 166.127 649.812 166.185 649.525 166.185C648.943 166.185 648.476 165.98 648.476 165.047V159.972H650.413V158.182ZM655.084 168.198C656.624 168.198 657.544 167.476 657.966 166.651H658.043V168H660.267V161.429C660.267 158.834 658.152 158.054 656.279 158.054C654.214 158.054 652.629 158.974 652.118 160.764L654.278 161.071C654.508 160.4 655.16 159.825 656.292 159.825C657.366 159.825 657.954 160.374 657.954 161.339V161.378C657.954 162.043 657.257 162.075 655.525 162.26C653.62 162.464 651.798 163.033 651.798 165.245C651.798 167.175 653.211 168.198 655.084 168.198ZM655.684 166.498C654.719 166.498 654.029 166.057 654.029 165.207C654.029 164.318 654.802 163.947 655.838 163.8C656.445 163.717 657.66 163.564 657.96 163.321V164.478C657.96 165.571 657.078 166.498 655.684 166.498ZM666.981 168H669.353V162.439H674.792V160.451H669.353V156.897H675.368V154.909H666.981V168ZM680.898 168.192C683.774 168.192 685.602 166.165 685.602 163.129C685.602 160.087 683.774 158.054 680.898 158.054C678.021 158.054 676.193 160.087 676.193 163.129C676.193 166.165 678.021 168.192 680.898 168.192ZM680.911 166.338C679.319 166.338 678.539 164.919 678.539 163.123C678.539 161.327 679.319 159.888 680.911 159.888C682.477 159.888 683.257 161.327 683.257 163.123C683.257 164.919 682.477 166.338 680.911 166.338ZM693.734 163.871C693.734 165.366 692.667 166.108 691.644 166.108C690.532 166.108 689.79 165.322 689.79 164.075V158.182H687.476V164.433C687.476 166.792 688.819 168.128 690.749 168.128C692.219 168.128 693.255 167.354 693.702 166.255H693.805V168H696.048V158.182H693.734V163.871ZM700.651 162.247C700.651 160.828 701.508 160.01 702.729 160.01C703.924 160.01 704.64 160.796 704.64 162.107V168H706.954V161.749C706.96 159.396 705.618 158.054 703.592 158.054C702.122 158.054 701.112 158.757 700.664 159.85H700.549V158.182H698.338V168H700.651V162.247ZM712.86 168.173C714.547 168.173 715.308 167.169 715.672 166.453H715.813V168H718.088V154.909H715.768V159.805H715.672C715.321 159.096 714.598 158.054 712.866 158.054C710.597 158.054 708.814 159.831 708.814 163.104C708.814 166.338 710.546 168.173 712.86 168.173ZM713.505 166.274C711.978 166.274 711.172 164.932 711.172 163.091C711.172 161.263 711.965 159.952 713.505 159.952C714.995 159.952 715.813 161.186 715.813 163.091C715.813 164.996 714.982 166.274 713.505 166.274Z"
        fill="#7D868C"
      />
    </svg>
  );
}
